import { render, staticRenderFns } from "./KRouterLink.vue?vue&type=template&id=45c17d38&scoped=true&"
import script from "./KRouterLink.vue?vue&type=script&lang=js&"
export * from "./KRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./KRouterLink.vue?vue&type=style&index=0&id=45c17d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c17d38",
  null
  
)

component.options.__file = "KRouterLink.vue"
export default component.exports